import React from "react";
import { Toaster } from "react-hot-toast";

import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import RolesManager from "pages/Roles/RolesManager";
import { SE_PAGES } from "config/dashboardPages";

// SE admin Roles & Permissions page — permission matrix limited to SE pages, so
// an ADMINSE can create sub-admin logins scoped to the SE dashboard only.
const Main = () => (
  <RolesManager
    resourceOptions={SE_PAGES}
    title="SE Roles & Permissions"
    subtitle="Create SE sub-admin logins with access to selected SE pages"
  />
);

const SERolesPage = () => {
  return (
    <AccessController roles={["ADMINSE", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default SERolesPage;
